import { Component, OnInit,Inject } from '@angular/core';
import {MAT_DIALOG_DATA,MatDialog} from '@angular/material/dialog';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
const initParams = {
  appId: '1658640104427573',
  xfbml: true,
  version: 'v2.8'
};
@Component({
  selector: 'app-pdf-dialog',
  templateUrl: './pdf-dialog.component.html',
  styleUrls: ['./pdf-dialog.component.css']
})
export class PdfDialogComponent implements OnInit {
public pdf_link : any;
public pdf_dialog_value : any;
public pdf_img:any;
  constructor(private hpService: HpService,public dialog: MatDialog,@Inject(MAT_DIALOG_DATA) public data_dialog: any) {


   }

  ngOnInit() {
    this.pdf_dialog_value = this.data_dialog;


}



}
